module.exports = __webpack_public_path__ + "img/edit.425f1319.svg";